export default function validateNameToken(s: string) {
  const hasNoWhitespaceEdges = s.trim() === s;
  const isNotEmptyString = s !== '';
  const hasValue = !!s;

  return hasNoWhitespaceEdges && isNotEmptyString && hasValue;
}
